import { EButtonStyleType } from '@common/enums';

import { ThemeColorNames } from '../enums/color-names.enum';
import { ThemeFontTags } from '../enums/font-tags.enum';
import { ThemeFontWeights } from '../enums/font-families.enum';

/**
 * The `ngx-translate` key each theme vocabulary maps to.
 *
 * Four maps of the same shape used to sit as fields on four different settings components, which
 * made "what does this tag say in the UI" a question you answered by opening a component. They are
 * data about the vocabularies, not about any panel, so they live with the vocabularies.
 */
export const FONT_TAG_TRANSLATIONS = {
    [ThemeFontTags.leading]: 'theme_settings_font_leading',
    [ThemeFontTags.big]: 'theme_settings_font_big',
    [ThemeFontTags.small]: 'theme_settings_font_small',
    [ThemeFontTags.quote]: 'theme_settings_font_quote',
    [ThemeFontTags.signature]: 'theme_settings_font_signature',
    [ThemeFontTags.p]: 'theme_settings_font_paragraph',
    [ThemeFontTags.h1]: 'theme_settings_font_heading_1',
    [ThemeFontTags.h2]: 'theme_settings_font_heading_2',
    [ThemeFontTags.h3]: 'theme_settings_font_heading_3',
    [ThemeFontTags.h4]: 'theme_settings_font_heading_4',
    [ThemeFontTags.pre]: 'theme_settings_font_pre',
    [ThemeFontTags.button]: 'theme_settings_font_button',
} as const;

export const FONT_WEIGHT_TRANSLATIONS = {
    [ThemeFontWeights.light]: 'theme_settings_font_weight_light',
    [ThemeFontWeights.normal]: 'theme_settings_font_weight_normal',
    [ThemeFontWeights.bold]: 'theme_settings_font_weight_bold',
} as const;

export const COLOR_NAME_TRANSLATIONS = {
    [ThemeColorNames.light]: 'theme_settings_color_light',
    [ThemeColorNames.dark]: 'theme_settings_color_dark',
    [ThemeColorNames.primary]: 'theme_settings_color_primary',
    [ThemeColorNames.secondary]: 'theme_settings_color_secondary',
    [ThemeColorNames.accent]: 'theme_settings_color_accent',
} as const;

export const COLOR_DESCRIPTION_TRANSLATIONS = {
    [ThemeColorNames.light]: 'theme_settings_color_light_description',
    [ThemeColorNames.dark]: 'theme_settings_color_dark_description',
    [ThemeColorNames.primary]: 'theme_settings_color_primary_description',
    [ThemeColorNames.secondary]: 'theme_settings_color_secondary_description',
    [ThemeColorNames.accent]: 'theme_settings_color_accent_description',
} as const;

export const BUTTON_STYLE_TYPE_TRANSLATIONS = {
    [EButtonStyleType.primary]: 'control_appearance_primary',
    [EButtonStyleType.secondary]: 'control_appearance_secondary',
    [EButtonStyleType.custom]: 'control_appearance_custom',
    [EButtonStyleType.classic]: 'control_appearance_classic',
} as const;
